export default {
    hcDemandChart: null,
    formatRegion: [],
    childsDemandData: [],

    // 产品图表数据
    childsProductData: [],
    // 产品选中的地区
    selectProductRegion: [],
    // 埋点统计数据
    eventTracking: {},
}